export const amountFields = [
  'amount',
  'resaleAmount',
];
export const amountFieldsRemit = [
  'amount',
];

export default {
  amountFields, amountFieldsRemit,
};
